import { render, staticRenderFns } from "./DashboardAnalytics.vue?vue&type=template&id=4678fd4a"
import script from "./DashboardAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardAnalytics.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardAnalytics.vue?vue&type=style&index=0&id=4678fd4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
